const TYPE = "REQUEST:TRACK";

/*
    Pass all actions through by default.
*/
const RequestTracker =
	({ dispatch }) =>
	(next) =>
	(action) => {
		const { type } = action;

		if (/(@START|@INIT)/.test(type)) {
			dispatch({
				type: TYPE,
				direction: "outgoing",
				name: type.split("@")[0],
			});
		}

		if (/(@SUCCESS|@FAIL)/.test(type)) {
			dispatch({
				type: TYPE,
				direction: "incoming",
				name: type.split("@")[0],
				succeeded: type.split("@")[1] === "SUCCESS",
			});
		}

		next(action);
	};

export default RequestTracker;
